import React from 'react';
import { Badge } from '@planne-software/uni/Badge';
import { Button } from '@planne-software/uni/Button';
import { useTranslate } from '@src/core/hooks';
import { CouponAffectedChips, CouponAffectedExpandRow, CouponAffectedLabel, CouponAffectedRoot } from '../../styles';

import { useCartCouponAffectedProducts } from './useCartCouponAffectedProducts';

type CartCouponAffectedProductsProps = {
  productNames: string[];
  maxVisible?: number;
};

export const CartCouponAffectedProducts = (props: CartCouponAffectedProductsProps) => {
  const { productNames, maxVisible } = props;
  const { i18n } = useTranslate();
  const { visibleProducts, hiddenCount, expanded, expand } = useCartCouponAffectedProducts({
    productNames,
    maxVisible,
  });

  if (!productNames.length) {
    return null;
  }

  return (
    <CouponAffectedRoot data-testid='cart-coupon-affected-products'>
      <CouponAffectedLabel>{i18n('checkout_coupon_affected_products')}</CouponAffectedLabel>
      <CouponAffectedChips>
        {visibleProducts.map((name) => (
          <Badge key={name} label={name} color='default' />
        ))}
        {!expanded && hiddenCount > 0 ? <Badge label={`+${hiddenCount}`} color='default' /> : null}
      </CouponAffectedChips>
      {maxVisible && hiddenCount > 0 ? (
        <CouponAffectedExpandRow>
          <Button type='button' variant='text' size='sm' color='neutral' onClick={expand}>
            {i18n('checkout_view_more')}
          </Button>
        </CouponAffectedExpandRow>
      ) : null}
    </CouponAffectedRoot>
  );
};

export default CartCouponAffectedProducts;
